import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import '../styles/Style.css';
import { PageOne, PageTwo, CreateContact, CreateClub } from "../components/Modals";
import { paymentStatus } from '../services/api';
import { Modal, Button } from "react-bootstrap";

const CreateQR = () => {
  const navigate = useNavigate(); // For routing
  const [activeModal, setActiveModal] = useState(null);
  const isMounted = useRef(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isClub, setIsClub] = useState(false);
  const [clubCount, setClubCount] = useState(false);
  const [isSingle, setIsSingle] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [createdLink, setCreatedLink] = useState(false);
  const [createdCount, setCreatedCount] = useState(false);

  // Check if user is logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }

    if (!isMounted.current) {
      checkPaymentStatus();
      isMounted.current = true;
    }

  }, [navigate]);

  // Add/remove body class when the page loads/unloads
  useEffect(() => {
    document.body.classList.add('loged-body');
    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  const checkPaymentStatus = async () => {
    try {
      const response = await paymentStatus();
      console.log('response',response);
      setIsPaid(response.data.paid);
      setCreatedLink(response.data.newlyCreatedLink);
      setCreatedCount(response.data.createdCount);
      setIsClub(response.data.totalAmountClub);
      setClubCount(response.data.totalClubCount);
      setIsSingle(response.data.totalAmountSingle);
      setIsDisplay(true);
    } catch (err) {
      console.log("Something went wrong. Please try again.");
    }
  };

  const handlePaymentClick = () => {
    navigate("/pricing");
    setShowPlanModal(true);
  };

  // Handle card click (either open modal or navigate to page)
  const handleCardClick = (text, createdLink) => {
    if (text === "Page Three") {
      navigate("/page3");
    } else {
      setActiveModal({text,createdLink});
    }
  };

  // Close modal
  const closeModal = () => setActiveModal(null);

  // Render modal content
  const renderModalContent = () => {
    switch (activeModal?.text) {
      case "Create Contact Page":
        return <CreateContact closeModal={closeModal}/>;
      case "club form":
        return <CreateClub closeModal={closeModal} createdLink={activeModal?.createdLink} createdCount={createdCount} />;
      case "Page One":
        return <PageOne closeModal={closeModal} />;
      case "Page Two":
        return <PageTwo closeModal={closeModal} />;
      default:
        return null;
    }
  };

  const handlePayment = async () => {
    navigate("/subscribe");
  };

  const cardData = [
    { text: "Create Contact Page", modal: "CreateContact" },
    // { text: "Page One", modal: "PageOne" },
    // { text: "Page Two", modal: "PageTwo" },
    // { text: "Page Three", modal: "PageThree" },
  ];

  return (
    <>
      <Sidebar />
      <WebNav />
      <div className="mt-4 user-panel-body">
        {!isDisplay ?(
          <div className="text-center mt-5">
          <span>Loading...</span>
        </div>
        ) : (
          <>
            {!isPaid && (
              <div className="alert alert-warning d-flex justify-content-between align-items-center">
                <span>To create your QR codes, you must subscribe to one of our plans.</span>
                <Button variant="primary" onClick={handlePaymentClick}>
                  View Plans
                </Button>
              </div>
            )}
          </>
        )}
        
        <div className="d-flex justify-content-between align-items-center">
          <h3>Create QR Codes</h3>
        </div>
        {isClub &&(
          <div className="d-flex justify-content-between align-items-center">
            <p>You have {clubCount} remaining QR codes available to create as part of your Club Administrator plan.</p>
          </div>
        )}

        {/* Cards Section */}
        <div className="row mt-4 g-4">
          {cardData.map((card, index) => (
            <>
              <div className="col-md-2 col-sm-6" key={index}>
              <div
                className="card text-center shadow-sm p-3 d-flex align-items-center justify-content-center"
                style={{
                  cursor: "pointer",
                  transition: "transform 0.2s ease, border 0.2s ease, color 0.2s ease", // Add transition for border and color
                  minHeight: "120px",
                  height: "120px",
                  border: isClub ? "2px solid #28a745" : "2px solid gray",
                  color: isClub ? "#28a745" : "gray",
                  pointerEvents: isClub ? "auto" : "none",
                }}
                onClick={() => handleCardClick('club form', createdLink)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.border = "2px solid transparent";
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.background = "#28a745";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.border = "2px solid #28a745";
                  e.currentTarget.style.color = "#28a745";
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <h5 className="m-0">Club Administrator</h5>
              </div>
            </div>

            <div className="col-md-2 col-sm-6" key={index}>
              <div
                className="card text-center shadow-sm p-3 d-flex align-items-center justify-content-center"
                style={{
                  cursor: "pointer",
                  transition: "transform 0.2s ease, border 0.2s ease, color 0.2s ease", // Add transition for border and color
                  minHeight: "120px",
                  height: "120px",
                  border: isSingle ? "2px solid #28a745" : "2px solid gray",
                  color: isSingle ? "#28a745" : "gray",
                  pointerEvents: isSingle ? "auto" : "none",
                }}
                onClick={() => handleCardClick(card.text, createdLink)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.border = "2px solid transparent";
                  e.currentTarget.style.color = "#fff";
                  e.currentTarget.style.background = "#28a745";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.border = "2px solid #28a745";
                  e.currentTarget.style.color = "#28a745";
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <h5 className="m-0">Single Contact Page</h5>
              </div>
            </div>
            </>
          ))}
        </div>
        {isPaid && renderModalContent()}
        
        <Modal show={showPlanModal} onHide={() => setShowPlanModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Choose Your Plan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="plan-card shadow-sm p-3 mb-4">
              <h5>Annual Plan</h5>
              <p>1 Euro per year</p>
              <ul>
                <li>Create one dynamic contact page</li>
                <li>Unlimited scans</li>
                <li>Multiple downloads</li>
                <li>Activate/deactivate anytime</li>
                <li>Delete anytime</li>
              </ul>
              <Button variant="success" onClick={() => handlePayment()}>
                Subscribe Now
              </Button>
            </div>
          </Modal.Body>
        </Modal>

      </div>
    </>
  );
};

export default CreateQR;
